import React, { Component } from 'react';
import PropTypes from 'prop-types';

// 기타 react
import { FormattedMessage } from 'react-intl'
import Dropzone from 'react-dropzone'

// material-ui
import LineButton from "@material-ui/core/Button";

class ButtonFileUploaderComponent extends Component {
    constructor(props) {
        super(props)
        this.state = { 
            //accepted: [],
            //rejected: [],
            dropzoneActive: false,
            droppedFileCnt:0,
            //fileNames: '',
            errorMsg: '',
        }

    }

    shouldComponentUpdate(nextProps, nextState){
        if (
            //nextState.accepted === this.state.accepted &&
            //nextState.rejected === this.state.rejected &&
            nextProps.fileNames === this.props.fileNames &&
            nextState.dropzoneActive === this.state.dropzoneActive &&
            nextState.droppedFileCnt === this.state.droppedFileCnt
            //nextState.errorMsg === this.state.errorMsg
        ) {
            console.log("InputFileUploaderComponent >> shouldComponentUpdate : false");
            return false;
        }

        console.log("InputFileUploaderComponent >> shouldComponentUpdate : true");
        return true;
    }

    onDragEnter() {
    
        this.setState({
            dropzoneActive: true
        });
    }

    onDragLeave() {
        this.setState({
            dropzoneActive: false
        });
    }

    onDropRejected(...args) {
        console.log("onDropRejected = ", ...args)
        this.setState({
            dropzoneActive: false
        });
    }

    onDrop(accepted, rejected) {
        let fileNames = "";
        let errorMsg = "";

        if(rejected.length > 0){
            const maxFilesize = this.props.maxSize * 1024 * 1024;
            rejected.map( (f, i) => {
                fileNames = fileNames + f.name
                if (this.props.multiple && i !== rejected.length - 1) {
                    fileNames = fileNames + ", ";
                }

                errorMsg = (f.size >= maxFilesize) ? <FormattedMessage id="dropzone.file.size.excess" values={{ maxFilesize: this.props.maxSize}} /> 
                    : <FormattedMessage id="dropzone.file.invalid.ext" values={{ fileExts: this.props.accept}} />;

                return fileNames;
            })
        } else if(accepted.length > 0) { // 일단 이런방식으로 처리.. IE11에서 onDrop을 두번호출하는 버그 있음. 추후 버전 react-dropzone 버전업데이트 필요
            accepted.map( (f, i) => {
                fileNames = fileNames + f.name
                if (this.props.multiple && i !== accepted.length - 1) {
                    fileNames = fileNames + ", ";
                }
                return fileNames;
            })
        }

        this.props.setSelectedFile(fileNames, accepted);

        this.setState({
            //files,
            dropzoneActive: false,
            droppedFileCnt: accepted.length + rejected.length,
            //accepted,
            //rejected,
            //fileNames: fileNames,
            errorMsg: errorMsg,
        });

    }

    render() {
        const { dropzoneActive, errorMsg } = this.state;
        const { accept, maxSize, multiple, fileNames } = this.props;
        const overlayStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            padding: '2.5em 0',
            background: 'rgba(0,0,0,0.5)',
            textAlign: 'center',
            color: '#fff'
        };
        return (
            <Dropzone
                disableClick
                multiple={multiple}
                style={{position: "relative"}}
                accept={accept}
                onDrop={this.onDrop.bind(this)}
                onDragEnter={this.onDragEnter.bind(this)}
                onDragLeave={this.onDragLeave.bind(this)}
                onDropRejected={this.onDropRejected.bind(this)}
                maxSize={maxSize * 1024 * 1024}
            >
                {({ open }) => ( 
                    <div>
                        { dropzoneActive && <div style={overlayStyle}><FormattedMessage id="dropzone.file.drop" /></div> }
                            <LineButton
                                variant={"outlined"}
                                className={"lineButton"}
                                style={{
                                    color: '#E7437E',
                                    borderColor: '#E7437E'
                                }}
                                onClick={open}
                            >
                                <FormattedMessage id="dropzone.file.select" />
                            </LineButton>

                            { fileNames ? 
                                <span className="fileNameContainer">{fileNames}</span>
                                :
                                <span className="fileNameContainer"><FormattedMessage id="dropzone.desc" /></span>
                            }
                            { errorMsg && <div className="fileNameContainerError">{errorMsg}</div>}
                            
                    </div>
                )}


            </Dropzone>
        );
    }
}

ButtonFileUploaderComponent.propTypes = {
    //accept: PropTypes.string.isRequired,
    maxSize: PropTypes.number.isRequired,
    multiple: PropTypes.bool.isRequired,
    setSelectedFile: PropTypes.func,
};

export default ButtonFileUploaderComponent;